import { render } from "./TableWrapper.vue?vue&type=template&id=32e5362f"
import script from "./TableWrapper.vue?vue&type=script&lang=js"
export * from "./TableWrapper.vue?vue&type=script&lang=js"

import "./TableWrapper.vue?vue&type=style&index=0&id=32e5362f&lang=css"

import exportComponent from "/app/tmp/blackhall/V3/v2026.12.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__